<template>
  <a-card :bordered="false">
    <div class="mb15">
      <a-button type="primary" @click="openModel">绑定商品</a-button>
    </div>
    <custom-page-table
      ref="table"
      :columns="getColumnsList()"
      :queryParams="searchQueryParams"
      :requestPromise="loadPromise"
      :enableSearch="false"
    >
      <span slot="action" slot-scope="rowItem">
        <a-popconfirm title="是否要删除绑定" @confirm="deleteProBind(rowItem.record.id)">
          <a>删除绑定</a>
        </a-popconfirm>
      </span>
    </custom-page-table>
    <a-modal title="商品绑定" :width="750" :footer="null" :visible="visible" @cancel="handleCancel">
      <a-form-model ref="ruleForm" :model="ruleForm" :rules="rules" :label-col="{ span: 5 }"
                    :wrapper-col="{ span: 15 }">
        <a-form-model-item label="所属供应商" prop="accountId">
          <a-select v-model="ruleForm.accountId" placeholder="请选择" @change="handleChange" style="max-width: 400px">
            <a-select-option v-for="item in providerList" :key="item.id" :value="item.id">
              {{ item.supplierName }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="关联商品" required>
          <a-button type="primary" @click="toSelectedProductEvent">选择商品</a-button>
          <span style="margin-left: 10px;">*仅能关联门票类型且未上架的自有产品</span>
        </a-form-model-item>
        <a-form-model-item v-if="ruleForm.productId" label="商品名称" prop="productId">
          <span style="margin-left: 10px;">{{ ruleForm.productId }} {{ ruleForm.productName }}</span>
        </a-form-model-item>
        <a-form-model-item label="选择票型" prop="optionId">
          <a-select v-model="ruleForm.optionId" placeholder="请选择票型" allowClear style="max-width: 400px">
            <a-select-option v-for="item in optionList" :key="item.optionId" :value="item.optionId">
              {{ item.optionName }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="长隆景点" prop="productCode">
          <a-select v-model="ruleForm.productCode" placeholder="请选择"
                    allowClear @change="handleTicketChange" style="max-width: 400px" :loading="ticketLoading">
            <a-select-option v-for="item in supplierTicketList" :key="item.parkCode" :value="item.parkCode">
              {{ item.portName }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="长隆票型" prop="thirdOptionId">
          <a-select v-model="ruleForm.thirdOptionId" placeholder="请选择"
                    allowClear @change="changeThirdOption"
                    @popupScroll="handlePopupScroll"
                    style="max-width: 320px" :loading="selectLoading">
            <a-select-option
              v-for="item in supplierTicketOptionList"
              :key="item.optionCode"
              :value="item.optionCode"
            >
              {{ item.optionName }}
            </a-select-option>
          </a-select>
          <a-button :disabled="isDisabled" style="margin-left: 15px;" @click="updateLoadList">刷新</a-button>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="{ span: 15,offset: 5 }">
          <a-button type="primary" @click="handleSubmit" :loading="submitLoading" style="width: 180px;">保存设置
          </a-button>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <selected-product-dialog
      :show="showSelectedDialog"
      ref="pageList"
      :itemNames="['search_proId','search_proName']"
      :query-params="selectedQueryParams"
      :requestPromise="loadProductPromise"
      row-key="proId"
      @close="showSelectedDialog=false"
      :columns="getGoodsColumns()"
    >
      <a-form-item label="商品ID" slot="search_proId" v-bind="currentDialogLayout">
        <a-input v-model="selectedQueryParams.proId" style="width: 170px" placeholder="请输入商品ID"></a-input>
      </a-form-item>
      <a-form-item label="商品名称" slot="search_proName" v-bind="currentDialogLayout">
        <a-input v-model="selectedQueryParams.proName" style="width: 170px" placeholder="请输入商品名称"></a-input>
      </a-form-item>
      <template slot="proTypeSlot" slot-scope="rowItem">{{ rowItem.text|productTypeName }}</template>
      <template slot="action" slot-scope="rowItem">
        <a-button type="primary" @click="onSourceItemClick(rowItem.record)">选择</a-button>
      </template>
    </selected-product-dialog>
  </a-card>
</template>

<script>
import ChimelongTicketMixins from './ChimelongTicketMixins'
import SelectedProductDialog from '@/customComponents/SelectedProductDialog/SelectedProductDialog'

export default {
  name: 'ChimelongConnection',
  mixins: [ChimelongTicketMixins],
  components: { SelectedProductDialog },
  data() {
    return {
      currentDialogLayout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 18 }
      },
      searchQueryParams: {},
      selectedQueryParams: {
        proName: '',
        proId: '',
        proSource: 0,
        proStatus: 0,
        proType: 1
      },
      loadPromise: params => this.getListPromise(params),
      loadProductPromise: params => this.getProductListPromise(params),
      visible: false,
      showSelectedDialog: false,
      ruleForm: {
        accountId: undefined,//账户id
        id: 0,
        productCode: undefined,
        optionId: undefined,//魔方产品票型id
        productId: undefined,//魔方产品id
        productName: '',
        thirdOptionName: '',//长隆票型名称
        thirdOptionId: undefined//长隆票型id
      },
      rules: {
        accountId: [{ required: true, message: '请选择供应商', trigger: 'change' }],
        productId: [{ required: true, message: '请关联商品', trigger: 'change' }],
        optionId: [{ required: true, message: '请选择票型', trigger: 'change' }],
        productCode: [{ required: true, message: '请选择长隆景点', trigger: 'change' }],
        thirdOptionId: [{ required: true, message: '请选择长隆景点', trigger: 'change' }]
      },
      providerList: [],
      optionList: [],
      supplierTicketList: [],
      supplierTicketOptionList: [],
      submitLoading: false,
      submitFormData: '',
      pageNum: 1,
      pageSize: 500,
      isDisabled: true,
      loadingMore: false,
      selectLoading: false,
      ticketLoading: false
    }
  },
  mounted() {
  },
  methods: {
    toSelectedProductEvent() {
      this.showSelectedDialog = true
    },
    // 获取表格数据接口
    getListPromise(params) {
      this.getLogUtils().logWithTag('==getListPromise==', params)
      return this.getHttpServices().getProService().post('chimelong/product/all', params)
    },
    getProductListPromise(params) {
      return this.getHttpServices().getProService().post('api/v2/productManage/findProductList', params)
    },
    //商品数据点击
    onSourceItemClick(item) {
      this.getTicketOptionList(item.proId)
      this.ruleForm.productName = item.proName
      this.ruleForm.productId = item.proId
      this.ruleForm.optionId = undefined
      this.ruleForm.productCode = undefined
      this.ruleForm.thirdOptionId = undefined
      this.optionList = []
      this.showSelectedDialog = false
    },
    //获取票型列表
    getTicketOptionList(proId) {
      this.getHttpServices().getProService().get('v2/ydbus/product/getTicketOptionList?proId=' + proId).then(res => {
        this.getLogUtils().logWithTag('getTicketOptionList', res)
        if (res && res.length > 0) {
          this.optionList = res
        } else {
          this.optionList = []
        }
      }).catch(reason => {
        this.optionList = []
        this.showNetWorkErrorMessage(reason)
      })
    },
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.submitData()
        } else {
          this.getLogUtils().logWithTag('error submit!!')
          return false
        }
      })
    },
    submitData() {
      this.submitLoading = true
      let params = JSON.parse(JSON.stringify(this.ruleForm))
      this.getLogUtils().logWithTag('params', params)
      this.getHttpServices().getProService().post('chimelong/save-edit', params).then(res => {
        this.getLogUtils().logWithTag('submitData', res)
        this.$message.success('保存成功')
        this.visible = false
        this.loadingMore = false
        this.resetFrom()
        this.$refs.table.refresh(true)
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    },
    //解除绑定
    deleteProBind(id) {
      this.getHttpServices().getProService().post('chimelong/delete/' + id).then(res => {
        this.getLogUtils().logWithTag('deleteProBind', res)
        this.$message.success('删除绑定成功')
        this.$refs.table.refresh(true)
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    //获取供应商列表
    getProviderList() {
      let params = {
        merchantId: this.$store.getters.userInfo.merchantId,
        platformId: this.getPlatformConfig().platformId
      }
      this.getHttpServices().getProService().post('chimelong/account/List', params).then(res => {
        this.getLogUtils().logWithTag('getProviderList', res)
        if (res && res.length > 0) {
          this.providerList = res
        }
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    handleChange(value) {
      this.ruleForm.productCode = undefined
      this.ruleForm.thirdOptionId = undefined
      this.loadingMore = false
      this.supplierTicketList = []
      this.supplierTicketOptionList = []
      this.getChimelongTicketList(value)
    },
    getChimelongTicketList(id) {
      this.ticketLoading = true
      this.getHttpServices().getProService().get('chimelong/account/choose/' + id).then(res => {
        this.getLogUtils().logWithTag('getChimelongTicketList', res)
        if (res && res.length > 0) {
          this.supplierTicketList = res
        } else {
          this.supplierTicketList = []
        }
      }).catch(reason => {
        this.showNetWorkErrorMessage(reason)
        this.supplierTicketList = []
      }).finally(() => this.ticketLoading = false)
    },
    openModel() {
      this.visible = true
      this.resetFrom()
      this.providerList = []
      this.optionList = []
      this.supplierTicketList = []
      this.supplierTicketOptionList = []
      this.getProviderList()
    },
    handleCancel() {
      this.visible = false
      this.loadingMore = false
    },
    handleTicketChange(value) {
      this.getLogUtils().logWithTag('handleTypeChange', value)
      this.supplierTicketOptionList = []
      this.ruleForm.thirdOptionId = undefined
      this.pageNum = 1
      this.isDisabled = true
      this.getChimelongOptionList(value)
    },
    handlePopupScroll() {
      this.getLogUtils().logWithTag('handlePopupScroll', this.loadingMore)
      this.updateLoadList()
    },
    updateLoadList() {
      if (this.loadingMore) {
        this.pageNum += 1
        this.loadingMore = false
        setTimeout(() => {
          this.getChimelongOptionList(this.ruleForm.productCode)
        }, 600)
      }
    },
    getChimelongOptionList(portId) {
      let params = {
        limitDto: { pageNum: this.pageNum, pageSize: this.pageSize },
        id: this.ruleForm.accountId,
        optionId: this.ruleForm.optionId,
        portId: portId,
        productId: this.ruleForm.productId
      }
      this.selectLoading = true
      this.getHttpServices().getProService().post('chimelong/option', params).then(res => {
        this.getLogUtils().logWithTag('getChimelongOptionList', res)
        if (res) {
          let list = res.data
          if (list && list.length > 0) {
            this.loadingMore = true
            this.supplierTicketOptionList = [...this.supplierTicketOptionList, ...list]
          } else {
            this.loadingMore = false
          }
          if (this.supplierTicketOptionList && this.supplierTicketOptionList.length > 10) {
            this.isDisabled = true
          } else {
            this.loadingMore = true
            this.isDisabled = false
          }
        } else {
          this.loadingMore = false
          this.supplierTicketOptionList = []
        }
      }).catch(reason => {
        this.loadingMore = false
        this.showNetWorkErrorMessage(reason)
        this.supplierTicketOptionList = []
      }).finally(() => this.selectLoading = false)
    },
    changeThirdOption(value) {
      this.getLogUtils().logWithTag('changeThirdOption', value)
      if (value) {
        this.ruleForm.thirdOptionName = this.supplierTicketOptionList.filter(item => item.optionCode == value)[0].optionName
      } else {
        this.ruleForm.thirdOptionName = ''
      }
      this.getLogUtils().logWithTag('changeThirdOption', this.ruleForm.thirdOptionName)
    },
    resetFrom() {
      this.ruleForm = {
        accountId: undefined,//账户id
        id: 0,
        productCode: undefined,
        optionId: undefined,//魔方产品票型id
        productId: undefined,//魔方产品id
        productName: '',
        thirdOptionName: '',//长隆票型名称
        thirdOptionId: undefined//长隆票型id
      }
    },
    getGoodsColumns() {
      return [
        {
          title: '商品ID',
          dataIndex: 'proId',
          width: '100px'
        },
        {
          title: '商品名称',
          dataIndex: 'proName'
        },
        {
          title: '商品分类',
          dataIndex: 'proType',
          width: '100px',
          scopedSlots: { customRender: 'proTypeSlot' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '100px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    },
    getColumnsList() {
      return [
        {
          title: '商品ID',
          dataIndex: 'productId'
        },
        {
          title: '商品名称',
          dataIndex: 'productName',
          width: '25%'
        },
        {
          title: '票型',
          dataIndex: 'optionName'
        },
        {
          title: '类型',
          dataIndex: 'categoryName'
        },
        {
          title: '更新时间',
          dataIndex: 'gmtModified',
          width: '120px'
        },
        {
          title: '供应商名称',
          dataIndex: 'accountName'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '100px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    }
  }
}
</script>
<style scoped>
.mb15 {
  margin-bottom: 15px;
}
</style>
